export default __webpack_public_path__ + "static/media/bloodthirst.6f7e874d.png";